<template>
  <MainLayout>
    <div class="container">
      <div class="box">
        <b-button class="float-right" v-if="$hasPermission('additionalService.add')" @click="newModel"
          >Nuevo Servicio adicional</b-button
        >
        <h2>Servicios adicionales</h2>
        <hr />

        <b-form
          @submit="
            (evt) => {
              evt.preventDefault();
              DBgetItems();
              //this.$root.$emit(
              // 'bv::refresh::table',
              // 'additional-services-index-list'
              //);
            }
          "
        >
          <div class="row">
            <b-form-group class="col-2" label="Buscar">
              <b-form-input v-model="filters.search" type="text" />
            </b-form-group>
            <b-form-group class="col-2" label=".">
              <b-button type="submit" variant="primary">Buscar</b-button>
            </b-form-group>
            <b-form-group class="col-8" label=".">
              <div class="container">
                <div class="row justify-content-end">
                  <b-button variant="primary" @click="DBupdateOrder"
                    >Guardar orden</b-button
                  >
                </div>
              </div>
            </b-form-group>
          </div>
        </b-form>

        <b-overlay
          id="overlay-background"
          :show="showLoadingUpdate"
          variant="dark"
          opacity="0.61"
          :blur="'2px'"
          rounded="sm"
        >
          <b-table-simple striped hover class="table-item cursor-pointer">
            <b-thead>
              <!-- Static column Names -->
              <b-th> </b-th>
              <!-- <b-th> order </b-th> -->
              <b-th> ID </b-th>
              <b-th> Tipo </b-th>
              <b-th> Codigo </b-th>
              <b-th> Nombre </b-th>
              <b-th> Estado </b-th>
              <b-th> Aeropuerto </b-th>
              <b-th> Acciones </b-th>
            </b-thead>

            <!-- Draggable rows -->
            <draggable
              :class="{ [`cursor-grabbing`]: dragging === true }"
              v-model="arrayRows"
				:disabled="
							!$hasPermission('additionalService.updateOrder')
						"
              group="items"
              @start="dragging = true"
              @end="dragging = false"
              @change="onChangeDraggable"
              tag="tbody"
            >
              <b-tr v-for="item in arrayRows" :key="item.id" class="item-row">
                <b-td>
                  <md-icon icon="drag_handle" />
                </b-td>
                <!-- <b-td>{{ item.order }}</b-td> -->
                <b-td>{{ item.id }}</b-td>
                <b-td>{{ item.type }}</b-td>
                <b-td>{{ item.code }}</b-td>
                <b-td>{{ item.name }}</b-td>
                <b-td>{{ item.status }}</b-td>
                <b-td>{{ item.restrictedByIata }}</b-td>
                <b-td
                  ><div class="text-center">
                    <b-button
                      @click="event => editModel(item.id)"
                      type="button"
                      size="sm"
                      class="mr-1"
                      variant="info"
                    >
                      <md-icon icon="edit" />
                    </b-button>
                    <b-button
					v-if="
											$hasPermission(
												'additionalService.delete'
											)
										"
                      @click="
                        (event) => deleteModel(item.item, item.index, event)
                      "
                      type="button"
                      size="sm"
                      class="mr-1"
                      variant="danger"
                    >
                      <md-icon icon="delete" />
                    </b-button></div
                ></b-td>
              </b-tr>
            </draggable>
          </b-table-simple>
        </b-overlay>
      </div>
      <hr />
    </div>
    <Single ref="single" :success-callback="successCallback" :unableEdit="unableEdit" />
  </MainLayout>
</template>

<script>
import MainLayout from "../layout/MainLayout";
import Single from "./Single";
import api from "../../../api.js";
import draggable from "vuedraggable";

export default {
  name: "Addditional-services-crud",
  components: { MainLayout, Single, draggable },
  data() {
    return {
		unableEdit: false,
      //datos de tabla
      dragging: false,
      totalRows: 0,
      arrayRowsOriginal: [],
      arrayRows: [],
      indexUpdate: 0, //variable que sirve como indice para el bucle de actualizacion de update
      showLoadingUpdate: false,
      //modales y filtros
      modalInfo: {
        modelId: -1,
        title: "Destino",
      },
      filters: {
        search: "",
      },
      modelColumns: [
        { key: "id", label: "ID" },
        { key: "order", label: "order" },
        { key: "type", label: "Tipo" },
        { key: "code", label: "Codigo" },
        { key: "name", label: "Nombre" },
        { key: "status", label: "Estado" },
        { key: "restrictedByIata", label: "Aeropuerto" },
        { key: "actions", label: "Acciones" },
      ],
    };
  },
  mounted() {
    this.DBgetItems();
  },
  methods: {
	editModel(id) {
			this.unableEdit = !this.$hasPermission("additionalService.edit");
			this.$refs["single"].loadModel(id);
		},
    DBupdateOrder() {
      //iniciamos la primera actualizacio de orden
      if (this.indexUpdate < this.arrayRows.length) {
        //mostramos el overlay de carga
        this.showLoadingUpdate = true;
        //recuperamos el primer item a actualizarse
        let item = this.arrayRows[this.indexUpdate];
        //hacemos la peticion al servidor
        api(this)
          .put(`/additional-services/${item.id}/update-order`, {
            order: item.order,
          })
          .then(() => {
            //incrementamos el indice
            this.indexUpdate++;
            this.DBupdateOrder();
          })
          .catch((err) => {
            this.$root.handleRequestError(err);
          })
          .finally(() => {});
      } else {
        //ocultamos el overlay de carga
        this.showLoadingUpdate = false;
        //reiniciamos el indice de actualizacion
        this.indexUpdate = 0;
        this.$root.showAlert(`Se actualizó correctamente`);
      }
    },
    onChangeDraggable(ev) {
      console.log(ev);
      //capturamos el contexto de la aplicacion
      //   let me = this;
      //actualizamos la propierdad de orden basado en la posicion del array
      this.arrayRows.forEach(function (item, index) {
        // let itemA = { ...me.arrayRowsOriginal[index] }.order;
        // item.order = itemA;
        item.order = index + 1;
        // me.arrayRows[index].order = itemA;
      });
      //   //recuperamos las posiciones de los items intercambiados
      //   let posicionItemOrigen = ev.moved.oldIndex;
      //   let posicionItemDestino = ev.moved.newIndex;
      //   //creamos un objeto auxiliar para almacenar temporalmente el los item
      //   var itemAuxOrigen = { ...this.arrayRowsOriginal[posicionItemOrigen] };
      //   var itemAuxDestino = { ...this.arrayRowsOriginal[posicionItemDestino] };
      //   //creamos variables que almacenan el valor de orden
      //   var orderAuxOrigen = {
      //     ...this.arrayRowsOriginal[posicionItemOrigen],
      //   }.order;
      //   var orderAuxDestino = {
      //     ...this.arrayRowsOriginal[posicionItemDestino],
      //   }.order;
      //   //intercambiamos las posiciones entre los items
      //   this.arrayRowsOriginal[posicionItemOrigen] = itemAuxDestino;
      //   this.arrayRowsOriginal[posicionItemDestino] = itemAuxOrigen;
      //   //intercambiamos valores de orden entre los items seleccionados
      //   this.arrayRowsOriginal[posicionItemOrigen].order = orderAuxOrigen;
      //   this.arrayRowsOriginal[posicionItemDestino].order = orderAuxDestino;
      //   //refrescamos la variable array que se visualiza al usuario por la original modificada
      //   this.arrayRows = { ...this.arrayRowsOriginal };
      //   //enviamos la peticion al endpoint para guardar en la base de datos
      //   this.updateOrder(this.arrayRows[posicionItemOrigen]);
      //   this.updateOrder(this.arrayRows[posicionItemDestino]);
    },
    DBgetItems() {
      this.$root.api
        .get(`/additional-services`, {
          params: {
            limit: 500,
            offset: 0,
            sortBy: "",
            sortOrder: "desc",
            filters: this.filters,
          },
        })
        .then((res) => {
          this.totalRows = res.data.totalRows;
          this.arrayRows = JSON.parse(JSON.stringify(res.data.rows));
          this.arrayRowsOriginal = JSON.parse(JSON.stringify(res.data.rows));
        })
        .catch(this.$root.handleRequestError);
    },
    successCallback() {
      this.$root.$emit("bv::refresh::table", "additional-services-index-list");
    },
    newModel() {
      this.$refs["single"].loadModel(-1);
    },
    deleteModel(item) {
      this.$root.showWarning({
        okAction: (event, setLoading, close) => {
          setLoading(true);
          api(this)
            .delete(`/additional-services/${item.id}`)
            .then(() => {
              this.$root.showAlert("Registro Eliminado!", {
                variant: "warning",
              });
              this.$root.auxVars.loadResourcesOpts({
                vm: this,
                resourceNames: ["serviceTypesOpts"],
                forceRefresh: true,
              });
              this.successCallback();
              close();
            })
            .catch((err) => {
              this.$root.handleRequestError(err);
              close();
            });
        },
      });
    },
    updateOrder(item) {
      api(this)
        .put(`/additional-services/${item.id}/update-order`, {
          order: item.order,
        })
        .then(() => {
          this.$root.showAlert(`Se actualizó correctamente`);
        })
        .catch((err) => {
          this.$root.handleRequestError(err);
        })
        .finally(() => {});
    },
  },
};
</script>

<style scoped>
.cursor-grabbing * {
  cursor: grabbing !important;
}
.cursor-pointer {
	cursor: pointer;
}
.draggable-list {
  background: #3f51b5;
  color: #fff;
  border: 1px solid;
  height: 50vh;
}
.list-item {
  margin: 10px;
  padding: 40px;
  cursor: pointer;
  font-size: 18px;
  border-radius: 5px;
  background: #f44336;
  display: inline-block;
}
</style>
